// extracted by mini-css-extract-plugin
module.exports = {"bg_circle":"BackgroundCircles_bg_circle__3UYW4"};